import _ from "lodash";
import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  MEAL_PLAN_SUMMARY_INITIALIZATION,
  MEAL_PLAN_SUMMARY_CHANGE_DATE,
  EXTEND_MEAL_PLAN_SUMMARY,
  ON_DROP_PLAN_SUMMARY,
  MOVE_GRID_PLAN_SUMMARY,
  isLoading,
} from "../actions/constant";
import moment from "moment";
import { submit } from "redux-form";
import i18n from "../i18n";

const initialState = {
  isLoading: true,
  timeValue: moment().startOf("day"),
  grid: [],
  numOfColumn: 7,
  counterState: 0,
  lastDrop: null,
  selectedDate: "",
};

function gridMaker(userPlan, time, num) {
  time = moment(time).startOf("day");
  var grid = [];
  for (var i = 0; i < num; i++) {
    const thisTime = moment(time).add(i, "days");
    let thisData = [];
    if (userPlan && userPlan.length > 0) {
      thisData = userPlan.filter((filItem) => {
        return (
          parseInt(moment(filItem.date).format("D")) ==
          parseInt(thisTime.format("D"))
        );
      });
    }
    let meals = {};
    let nutVal = {
      calories: [],
      sugars: [],
      sodium: [],
      cholesterol: [],
    };
    // if (thisData && thisData.length > 0) {
    //   thisData = thisData[0];
    //   // thisData.map((item) => {
    //   if (thisData.breakfast) {
    //     meals = {
    //       ...meals,
    //       breakfast: _.unionBy(meals.breakfast, thisData.breakfast, "_id"),
    //     };
    //   } else if (thisData.lunch) {
    //     meals = {
    //       ...meals,
    //       lunch: _.unionBy(meals.lunch, thisData.lunch, "_id"),
    //     };
    //   } else if (thisData.dinner) {
    //     meals = {
    //       ...meals,
    //       dinner: _.unionBy(meals.dinner, thisData.dinner, "_id"),
    //     };
    //   } else if (thisData.supper) {
    //     meals = {
    //       ...meals,
    //       supper: _.unionBy(meals.supper, thisData.supper, "_id"),
    //     };
    //   } else if (thisData.snack1) {
    //     meals = {
    //       ...meals,
    //       snack1: _.unionBy(meals.snack1, thisData.snack1, "_id"),
    //     };
    //   } else if (thisData.snack2) {
    //     meals = {
    //       ...meals,
    //       snack2: _.unionBy(meals.snack2, thisData.snack2, "_id"),
    //     };
    //   } else if (thisData.snack3) {
    //     meals = {
    //       ...meals,
    //       snack3: _.unionBy(meals.snack3, thisData.snack3, "_id"),
    //     };
    //   }
    //   // });

    //   thisData = meals;
    // } else {
    //   thisData = undefined;
    // }
    if (thisData && thisData.length > 0) {
      thisData = thisData[0];
    } else {
      thisData = undefined;
    }
    grid.push({
      date: thisTime,
      nutrients: [],
      nutResult: [
        { id: "1400600000001000001", name: i18n.t("general.CALORIES"), value: 0, unit: " Cal" },
        { id: "1400600000001000067", name: i18n.t("general.SUGARS"), value: 0, unit: " g" },
        { id: "1400600000001000061", name: i18n.t("general.SODIUM"), value: 0, unit: " mg" },
        {
          id: "1400600000001000056",
          name: i18n.t("general.CHOLESTEROL"),
          value: 0,
          unit: " mg",
        },
      ],
      meals: [
        {
          type: 'breakfast',
          title: i18n.t("general.BREAKFAST_MEAL_CATEGORY"),
          foods: thisData ? thisData.breakfast : [],
        },
        {
          type: 'lunch',
          title: i18n.t("general.LUNCH_MEAL_CATEGORY"),
          foods: thisData ? thisData.lunch : [],
        },
        {
          type: 'dinner',
          title: i18n.t("general.DINNER_MEAL_CATEGORY"),
          foods: thisData ? thisData.dinner : [],
        },
        {
          type: 'supper',
          title: i18n.t("general.SUPPER_MEAL_CATEGORY"),
          foods: thisData ? thisData.supper : [],
        },
        {
          type: 'snack1',
          title: i18n.t("general.SNACK1_MEAL_CATEGORY"),
          foods: thisData ? thisData.snack1 : [],
        },
        {
          type: 'snack2',
          title: i18n.t("general.SNACK2_MEAL_CATEGORY"),
          foods: thisData ? thisData.snack2 : [],
        },
        {
          type: 'snack3',
          title: i18n.t("general.SNACK3_MEAL_CATEGORY"),
          foods: thisData ? thisData.snack3 : [],
        },
      ],
    });
  }

  //#region nutrient calculator
  grid.forEach((gridItem) => {
    gridItem.meals.forEach((meal) => {
      if (meal.foods && meal.foods.length > 0) {
        meal.foods.forEach((food) => {
          if (food.nutrients) {
            gridItem.nutrients = [...gridItem.nutrients, ...food.nutrients];
          }
        });
      }
    });

    gridItem.nutResult.forEach((item) => {
      gridItem.nutrients.forEach((nut) => {
        if (item.id == nut._id) {
          item.value = item.value + nut.size;
        }
      });
      if (item.value == 0) {
        item.value = 0;
      } else if (item.value != 0 && item.value < 1) {
        item.value = item.value.toPrecision(2);
      } else if (item.value >= 1 && item.value < 100) {
        item.value = item.value.toFixed(1);
      } else if (item.value >= 100) {
        item.value = Math.floor(item.value);
      }
    });
  });

  //endregion nutrient calculator
  return grid;
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_DRAG_OVER":
      state.grid.forEach((gridItem) => {
        gridItem.meals.forEach((meal) => {
          if (meal.id == action.item.id) {
            meal.onOver = action.state;
          }
        });
      });
    case getStarted(MEAL_PLAN_SUMMARY_INITIALIZATION):
    case getSucceeded(MEAL_PLAN_SUMMARY_INITIALIZATION):
      let userPlan = action.payload.data || [];
      let time = action.payload.now;
      if (time) {
        let selectedDate = moment(time).startOf("day").unix() * 1000;
        return {
          ...state,
          grid: gridMaker(userPlan, time, action.payload.num),
          timeValue: time,
          numOfColumn: action.payload.num,
          selectedDate: selectedDate,
        };
      };

    case getFailed(MEAL_PLAN_SUMMARY_INITIALIZATION):
    case getEnded(MEAL_PLAN_SUMMARY_INITIALIZATION):
      return {
        ...state,
        isLoading: false,
      };
    case getStarted(MEAL_PLAN_SUMMARY_CHANGE_DATE):
      return {
        ...state,
        isLoading: true,
      };
    case getSucceeded(MEAL_PLAN_SUMMARY_CHANGE_DATE):
      state.timeValue = action.payload;
      return {
        ...state,
      };
    case getFailed(MEAL_PLAN_SUMMARY_CHANGE_DATE):
    case getEnded(MEAL_PLAN_SUMMARY_CHANGE_DATE):
      return {
        ...state,
        isLoading: false,
      };
    case getSucceeded(EXTEND_MEAL_PLAN_SUMMARY):
      const { date, meal } = action.payload;
      state.grid.forEach((item, i) => {
        if (item.date == date) {
          if (item.meals && item.meals.length > 0) {
            item.meals.forEach((mealItem) => {
              if (mealItem.title == meal) {
                mealItem.unExtend = !mealItem.unExtend;
              }
            });
          }
        }
      });
      return { ...state, counterState: state.counterState + 1 };
    case getStarted(ON_DROP_PLAN_SUMMARY):
      return { ...state, isLoading: true };
    case getSucceeded(ON_DROP_PLAN_SUMMARY):
      var fromArray = action.payload.from.food.split("-");

      var dragedItem = {};
      state.grid.map((item) => {
        if (item.date.unix() * 1000 == fromArray[1]) {
          item.meals.map((meal) => {
            meal.isDropped = false;
            if (meal.type == fromArray[2]) {
              let meals = meal.foods;
              // meals.map((food, i) => {
              //   if (food._id == fromArray[0]) {
              //     dragedItem = food;
              //   }
              // });

              let isMatched = false;
              meal.foods = meals.filter((food) => {
                if (food._id == fromArray[0] && !isMatched) {
                  dragedItem = food;
                  isMatched = true;
                  return false;
                }
                return true;
              });
            }
          });
        }
      });
      state.grid.forEach((item, i) => {
        if (item.date.unix() * 1000 == action.payload.toTime) {
          item.meals.forEach((mealItem) => {
            mealItem.isDropped = false;
            if (
              mealItem.type ==
              action.payload.toMeal.toLowerCase()
            ) {
              mealItem.isDropped = true;
              if (mealItem.foods) {
                mealItem.foods.push(dragedItem);
              } else {
                mealItem.foods = [dragedItem];
              }
            }
          });
        }
      });

      //#region nutrient calculator

      state.grid.forEach((gridItem) => {
        //reset nutCalculate
        gridItem.nutrients = [];
        gridItem.nutResult = [
          {
            id: "1400600000001000001",
            name: i18n.t("general.CALORIES"),
            value: 0,
            unit: " Cal",
          },
          { id: "1400600000001000067", name: i18n.t("general.SUGARS"), value: 0, unit: " g" },
          { id: "1400600000001000061", name: i18n.t("general.SODIUM"), value: 0, unit: " mg" },
          {
            id: "1400600000001000056",
            name: i18n.t("general.CHOLESTEROL"),
            value: 0,
            unit: " mg",
          },
        ];
        //end
        gridItem.meals.forEach((meal) => {
          if (meal.foods && meal.foods.length > 0) {
            meal.foods.forEach((food) => {
              if (food.nutrients) {
                gridItem.nutrients = [...gridItem.nutrients, ...food.nutrients];
              }
            });
          }
        });

        gridItem.nutResult.forEach((item) => {
          gridItem.nutrients.forEach((nut) => {
            if (item.id == nut._id) {
              item.value = item.value + nut.size;
            }
          });
          if (item.value == 0) {
            item.value = 0;
          } else if (item.value != 0 && item.value < 1) {
            item.value = item.value.toPrecision(2);
          } else if (item.value >= 1 && item.value < 100) {
            item.value = item.value.toFixed(1);
          } else if (item.value >= 100) {
            item.value = Math.floor(item.value);
          }
        });
      });

      //endregion nutrient calculator

      return { ...state };
    case getFailed(ON_DROP_PLAN_SUMMARY):
      return { ...state };
    case getEnded(ON_DROP_PLAN_SUMMARY):
      return { ...state, isLoading: false };
    case getStarted(MOVE_GRID_PLAN_SUMMARY):
      return { ...state, isLoading: true };
    case getSucceeded(MOVE_GRID_PLAN_SUMMARY):
      userPlan = action.payload.data;
      time = action.payload.time;
      let selectedtime = moment(time).startOf("day").unix() * 1000;
      return {
        ...state,
        grid: gridMaker(userPlan, time, state.numOfColumn),
        timeValue: time,
        selectedDate: selectedtime,
      };
    case getFailed(MOVE_GRID_PLAN_SUMMARY):
      userPlan = undefined;
      time = action.payload.time;
      return {
        ...state,
        grid: gridMaker(userPlan, time, state.numOfColumn),
        timeValue: time,
      };

      return { ...state, isLoading: true };
    case getEnded(MOVE_GRID_PLAN_SUMMARY):
      return { ...state, isLoading: false };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/mealPlanSummaryReducer.js